module.exports = __webpack_public_path__ + "img/93.3ce66899.jpg";